import { createFileRoute, redirect } from "@tanstack/react-router";

// The parent /users route already redirects in beforeLoad; this route exists
// so /users/$orgId is a recognized path (mirroring App.jsx) and redirects the
// same way if ever matched directly.
export const Route = createFileRoute("/_shell/users/$orgId")({
  beforeLoad: () => {
    throw redirect({ to: "/solutions", replace: true });
  },
});
